import React, { useEffect, useState } from "react";
import {} from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../config/config";
import { dateFormat } from "../utils";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import useFullPageLoader from "../hooks/useFullPageLoader";

export default function FinancialPartnerQuery() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [activePage, setActivePage] = useState(1);
  const [type, setType] = useState("Pending");
  const [query, setQuery] = useState("");
  const [iState, updateState] = useState({
    list: [],
    total: 0,
    id: "",
    fullName: "",
    personalEmail: "",
    companyName: "",
    companyeEmail: "",
    contactNumber: "",
    partnershipType: "",
    state: "",
    createdAt: "",
    //type: "Pending",
  });

  const {
    list,
    total,
    id,
    fullName,
    personalEmail,
    companyName,
    companyeEmail,
    contactNumber,
    state,
    partnershipType,
    createdAt,
    status,
    // type,
  } = iState;

  //*************Handel Query Status************ */
  const [BlockModal, setBlockModal] = useState(false);
  const handelBlockShow = (id) => {
    updateState({ ...iState, id: id });
    setBlockModal(true);
  };
  const handleBlockClose = () => {
    setBlockModal(false);
  };
  const handelUpdateStatus = async () => {
    try {
      const res = await axios({
        url: `${Url}/becomeAPartner`,
        method: "PUT",
        data: {
          partnerId: id,
          status: "Accepted",
        },
      });
      //console.log(res);
      if (res.data.status === 200) {
        handleBlockClose();
        handelSearchQuery(type, activePage, "");
        toast.success("Query status has been Mark as Complete successfully");
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*********************Handel View Details************************ */
  const [viewModal, setViewModal] = useState(false);
  const handleViewClose = () => {
    setViewModal(false);
  };
  const handelViewOpen = (data) => {
    console.log(data);
    setViewModal(true);
    updateState({
      ...iState,
      fullName: data.fullName,
      personalEmail: data.personalEmail,
      companyName: data.companyName,
      companyeEmail: data.companyeEmail,
      contactNumber: data.contactNumber,
      state: data.state,
      partnershipType: data.partnershipType,
      createdAt: data.createdAt,
    });
  };
  const handelViewetails = async () => {};

  //********Handel Search Query************ */
  const handelSearchQuery = async (type, page = 1, query) => {
    try {
      showLoader();
      console.log(type, "............", page, "///////////////", query);
      const res = await axios({
        url: `${Url}/becomeAPartner?status=${type}&page=${page}&search=${query}`,
        method: "GET",
      });
      hideLoader();
      //console.log(res);
      if (res.data.status === 200) {
        updateState({
          ...iState,
          list: res.data.data.qurieslisting,
          total: res.data.data.total,
        });
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //**************************Handel Category Filter**************** */
  const handelCategoryType = (e) => {
    //console.log(e.target.value);
    setType(e.target.value);
    handelSearchQuery(e.target.value, activePage, query);
  };

  //****************************Handel Search********************** */
  const handelSearch = (e) => {
    setQuery(e.target.value);
    handelSearchQuery(type, activePage, e.target.value);
  };

  //***************************Handel Pagination Onchange********** */
  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    handelSearchQuery(type, pageNo, query);
  };

  useEffect(() => {
    handelSearchQuery(type, activePage, query);
  }, []);
  return (
    <React.Fragment>
      <title>Financial Partner Queries Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <select
                className=""
                onChange={(e) => {
                  handelCategoryType(e);
                }}
              >
                <option value="Pending">Pending</option>
                <option value="Accepted">Completed</option>
              </select>
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
            </div>
            <h4 className="Title">Financial Partner Queries</h4>

            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Full Name</th>
                    <th>Mobile Number</th>
                    <th>Email</th>
                    <th>Company Name</th>
                    <th>View</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {list &&
                    list.length > 0 &&
                    list.map((item, i) => (
                      <tr key={i}>
                        <td>{++i}</td>
                        <td>{item.fullName}</td>
                        <td>{item.contactNumber}</td>
                        <td>{item.personalEmail}</td>
                        <td>{item.companyName}</td>
                        <td>
                          <button className="view_btn"
                            onClick={(e) => {
                              handelViewOpen(item);
                            }}
                          >
                            View
                          </button>
                        </td>
                        <td>
                          {item.status === "Pending" ? (
                            <button className="mark-as"
                              onClick={(e) => {
                                handelBlockShow(item._id);
                              }}
                            >
                              Mark as complete
                            </button>
                          ) : (
                            <button className="completed">Completed</button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ModalBox">
        {/* block or unblock model */}
        <Modal
          show={BlockModal}
          onHide={handleBlockClose}
        >
          <Modal.Header closeButton onClick={handleBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to mark it completed?</Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handleBlockClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={handelUpdateStatus}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>

        {/* end block unblock modal */}

        {/* Start View Details Modal */}
        <Modal show={viewModal} onHide={handleViewClose}>
          <Modal.Header closeButton onClick={handleViewClose}>
            <Modal.Title>Queries Management</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <table className="table table-striped table-bordered table-condensed table-hover">
                <thead></thead>
                <tbody>
                  <tr>
                    <th>Full Name</th>
                    <td>{fullName}</td>
                  </tr>
                  <tr>
                    <th>Mobile Number</th>
                    <td>{contactNumber}</td>
                  </tr>
                  <tr>
                    <th>Email Address</th>
                    <td>{personalEmail}</td>
                  </tr>
                  <tr>
                    <th>Company Name</th>
                    <td>{companyName}</td>
                  </tr>
                  <tr>
                    <th>Company Email</th>
                    <td>{companyeEmail}</td>
                  </tr>
                  <tr>
                    <th>State Name</th>
                    <td>{state}</td>
                  </tr>

                  <tr>
                    <th>Partner Type</th>
                    <td>{partnershipType}</td>
                  </tr>
                  <tr>
                    <th>Requested On</th>
                    <td>{dateFormat(createdAt)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handleViewClose}>
              Mark As Closed
            </button>
          </Modal.Footer>
        </Modal>
        {/* End view Modal */}
      </div>
    </React.Fragment>
  );
}
